
<div class="container-fluid">
    <div class="row top10 no-gutters">
        <div class="col-xs-12 col-md-6 vcenter">
            <h3>Manage AIMS Users</h3>
        </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />

    <div class="row top10">
        <form novalidate #permGrid="ngForm" *ngIf="(users|async) != null">
            <div>
                <aims-common-table
                [dataSource]="manageUsersDataSource"
                [header]="manageUsersColumns"
                [permissions]="permissions"
                id="ManageUsers"
                (rowEdit)="handleRowEdit($event)"
                (rowDeactivated)="handleRowDeactivated($event)"
                [defaultTableState]="defaultTableState"
                [stickyHeader]="true"
                [pageSize]="10"
                >
                    <ng-template aimsCommonTableDynamicToolbar>
                        <aims-common-button *ngIf="canCreate"
                          aria-label="Add" (click)="handleRowAdd()">
                            <mat-icon>add</mat-icon>
                            Add
                        </aims-common-button>
                    </ng-template>
                    <!-- Employee Record -->
                    <aims-common-table-dynamic-row id="employeeId">
                        <ng-template viewMode let-element >
                            {{ element.employeeId | getText:'employeeId':'fullName':employees }}
                        </ng-template>
                    </aims-common-table-dynamic-row>

                    <!--Tenant -->
                    <aims-common-table-dynamic-row id="tenantId">
                        <ng-template viewMode let-element>
                            {{ element.tenantId | getText:'tenantId':'tenantName':tenants }}
                        </ng-template>
                    </aims-common-table-dynamic-row>

                    <!-- Last Successful Login -->
                    <aims-common-table-dynamic-row id="lastSuccessfulLogin">
                        <ng-template viewMode let-element>
                            {{ element.lastSuccessfulLogin | date:'MM/dd/yyyy HH:mm' }}
                        </ng-template>
                    </aims-common-table-dynamic-row>

                    <!-- Last Password Reset -->
                    <aims-common-table-dynamic-row id="lastPasswordReset">
                        <ng-template viewMode let-element>
                            {{ element.lastPasswordReset | date:'MM/dd/yyyy HH:mm' }}
                        </ng-template>
                    </aims-common-table-dynamic-row>
                    
                    <!-- Password Expiration -->
                    <aims-common-table-dynamic-row id="passwordExpirationDate">
                        <ng-template viewMode let-element>
                            {{ element.passwordExpiration | date:'MM/dd/yyyy' }}
                        </ng-template>
                    </aims-common-table-dynamic-row>
                    
                    <!-- Active -->
                    <aims-common-table-dynamic-row id="active">
                        <ng-template viewMode let-element>
                            <div class="text-center">
                                <ng-container *ngIf="element.active">
                                    <img src="{{imgSrc}}/check.png" style="width:20px" />
                                </ng-container>
                                <ng-container *ngIf="!element.active">
                                    <img src="{{imgSrc}}/X.png" style="width:20px" />
                                </ng-container>
                            </div>
                        </ng-template>
                    </aims-common-table-dynamic-row>
                </aims-common-table>
            </div>
        </form>
    </div>

    <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>

</div>
